import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'login',
    loadComponent: () =>
      import('./components/login/login.component').then(
        (m) => m.LoginComponent,
      ),
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./components/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent,
      ),
  },
  {
    path: 'reset-password/:hash',
    loadComponent: () =>
      import('./components/reset-password/reset-password.component').then(
        (m) => m.ResetPasswordComponent,
      ),
  },
  {
    path: 'change-email/:hash',
    loadComponent: () =>
      import('./components/change-email/change-email.component').then(
        (m) => m.ChangeEmailComponent,
      ),
  },
  {
    // PAY-5113: confirmation link emailed to the NEW address lands here
    path: 'contact-change/email/:code',
    loadComponent: () =>
      import('./components/contact-change-email/contact-change-email.component').then(
        (m) => m.ContactChangeEmailComponent,
      ),
  },
  {
    path: 'agreement/sign',
    loadComponent: () =>
      import('./components/agreement-sign/agreement-sign.component').then(
        (m) => m.AgreementSignComponent,
      ),
  },
  {
    path: 'agreement',
    loadComponent: () =>
      import('./components/agreement/agreement.component').then(
        (m) => m.AgreementComponent,
      ),
  },
  {
    path: 'confirm-email/:userId',
    loadComponent: () =>
      import('./components/email-confirm/email-confirm.component').then(
        (m) => m.EmailConfirmComponent,
      ),
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AuthenticationRoutingModule {}
